export type EmailKey =
  | 'bookingKr'
  | 'bookingCom'
  | 'privacy'
  | 'it'
  | 'ethics'
  | 'leisure'
  | 'yeseul'
  | 'mgjin'
  | 'jhko'
  | 'khjang'
  | 'chaejh0425'
  | 'hosikk';

type EmailParts = {
  local: number[];
  domain: number[];
};

const EMAIL_PARTS: Record<EmailKey, EmailParts> = {
  bookingKr: {
    local: [112, 105, 110, 120, 98, 111, 111, 107, 105, 110, 103],
    domain: [115, 107, 112, 105, 110, 120, 46, 99, 111, 46, 107, 114],
  },
  bookingCom: {
    local: [112, 105, 110, 120, 98, 111, 111, 107, 105, 110, 103],
    domain: [115, 107, 112, 105, 110, 120, 46, 99, 111, 109],
  },
  privacy: {
    local: [112, 105, 110, 120, 95, 112, 114, 105, 118, 97, 99, 121],
    domain: [115, 107, 112, 105, 110, 120, 46, 99, 111, 46, 107, 114],
  },
  it: {
    local: [115, 107, 112, 105, 110, 120, 95, 105, 116],
    domain: [115, 107, 112, 105, 110, 120, 46, 99, 111, 46, 107, 114],
  },
  ethics: {
    local: [112, 105, 110, 120, 101, 116, 104, 105, 99, 115],
    domain: [115, 107, 112, 105, 110, 120, 46, 99, 111, 46, 107, 114],
  },
  leisure: {
    local: [112, 105, 110, 120, 108, 101, 105, 115, 117, 114, 101],
    domain: [115, 107, 46, 99, 111, 109],
  },
  yeseul: {
    local: [121, 101, 115, 101, 117, 108, 49, 50],
    domain: [115, 107, 46, 99, 111, 109],
  },
  mgjin: {
    local: [109, 103, 106, 105, 110],
    domain: [115, 107, 46, 99, 111, 109],
  },
  jhko: {
    local: [106, 104, 107, 111],
    domain: [115, 107, 46, 99, 111, 109],
  },
  khjang: {
    local: [107, 104, 106, 97, 110, 103],
    domain: [115, 107, 46, 99, 111, 109],
  },
  chaejh0425: {
    local: [99, 104, 97, 101, 106, 104, 48, 52, 50, 53],
    domain: [115, 107, 46, 99, 111, 109],
  },
  hosikk: {
    local: [104, 111, 115, 105, 107, 107],
    domain: [115, 107, 46, 99, 111, 109],
  },
};

const EMAIL_PLACEHOLDER = /\[\[EMAIL:([A-Za-z0-9_]+)\]\]/g;

function fromCharCodes(codes: number[]): string {
  let result = '';
  for (let i = 0; i < codes.length; i++) {
    result += String.fromCharCode(codes[i]);
  }
  return result;
}

export function decodeEmail(key: string): string {
  const parts = EMAIL_PARTS[key as EmailKey];
  if (!parts) {
    return '';
  }
  return fromCharCodes(parts.local) + String.fromCharCode(64) + fromCharCodes(parts.domain);
}

export function injectEmails(text: string): string {
  if (!text) {
    return text;
  }
  return text.replace(EMAIL_PLACEHOLDER, (_match, key: string) => decodeEmail(key));
}
